const UpArrowIcon = ({ className }: { className?: string }) => (
	<svg
		className={className}
		fill='currentColor'
		height='6'
		viewBox='0 0 10 6'
		width='10'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			clip-rule='evenodd'
			d='M9.52055 5.18693C9.71581 4.99167 9.71581 4.67508 9.52055 4.47982L5.35388 0.313154C5.15862 0.117892 4.84203 0.117892 4.64677 0.313154L0.480105 4.47982C0.284843 4.67508 0.284843 4.99167 0.480105 5.18693C0.675367 5.38219 0.99195 5.38219 1.18721 5.18693L5.00033 1.37381L8.81344 5.18693C9.0087 5.38219 9.32528 5.38219 9.52055 5.18693Z'
			fill='currentColor'
			fill-rule='evenodd'
		/>
	</svg>
)

export { UpArrowIcon }
